export default {"src":"/_next/static/media/at-t.22b0533c.svg","height":25,"width":61,"blurWidth":0,"blurHeight":0};